import { render, staticRenderFns } from "./ScwlOrderMonthChart.vue?vue&type=template&id=6b122e93&scoped=true"
import script from "./ScwlOrderMonthChart.vue?vue&type=script&lang=js"
export * from "./ScwlOrderMonthChart.vue?vue&type=script&lang=js"
import style0 from "./ScwlOrderMonthChart.vue?vue&type=style&index=0&id=6b122e93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b122e93",
  null
  
)

export default component.exports